
<template>
    <div class="tips" v-if="!isPdf">
        <el-alert v-for="e in $store.state.errors" :key="e.key" :title="e.message" type="error" :closable="false"></el-alert>
    </div>
    <div class="mcjs" v-loading.fullscreen.lock="loading" id="mcjs">
        <template v-for="(chil,idi) in mcjs" :key="idi">
            <p><b>{{intToChinese(idi+1)}}、{{chil.name}}</b></p>
            <p v-for="(item,idx) in chil.children" :key="idx">
                <b>（{{intToChinese(idx+1)}}）{{item.title || item.lei+'（类）'+item.kuan+'（款）'+item.xiang+'（项）'}}：</b>
                <reason type="textarea" classname="qksm widest" :name="'mcjs_'+(idi+1)+(item.code ? item.code : idx+1)" v-model:value="item.desc"></reason>
                <template v-if="num3 && item.title=='事业收入'">
                    <span class="hide_pdf red">
                        需结合本{{typeText}}所属事业单位实际举例说明。如**收入，**收入……等。<br />
                    </span>
                    <reason type="textarea" classname="qksm widest" name="mcjs_detail事业收入" v-model:value="qksm['mcjs_detail事业收入']" placeholder="如**收入，**收入……等"></reason>
                </template>
                <template v-if="num6 && item.title=='事业单位经营收入'">
                    <span class="hide_pdf red">
                        需结合本{{typeText}}所属事业单位实际举例说明。如**收入，**收入……等。<br />
                    </span>
                    <reason type="textarea" classname="qksm widest" name="mcjs_detail事业单位经营收入" v-model:value="qksm['mcjs_detail事业单位经营收入']" placeholder="如**收入，**收入……等"></reason>
                </template>
            </p>
        </template>
        <template v-if="(!isPdf || mcjsFour.length>0) && mcjs.length>0">
            <p>
                <b>四、{{typetext}}专业类名词</b><el-button size="small" @click="appendRow" v-if="!isPdf">添加行</el-button>
            </p>
            <p v-for="(item,idx) in mcjsFour" :key="idx">
                <el-button v-if="!isPdf" type="danger" size="small" @click="delect(item.id,idx, 1)">删除</el-button>
                <b>{{idx+1}}、<reason type="textarea" classname="qksm" :name="'专业名词'+item.id" v-model:value="item.name"></reason>：</b>
                <reason type="textarea" classname="qksm widest" :name="'专业名词解释'+item.id" v-model:value="item.value"></reason>
            </p>
        </template>
    </div>
</template>
<script>
    import reason from '@/components/reason.vue'
    import { getDivList, getKemuQuery, editQksm } from '@/api/index.js'
    import { getBdata } from "@/api/zone.js";
    export default {
        name: 'mcjs',
        components: {
            reason
        },
        props: {
            qksmData: {
                type: Object,
                default: {}
            },
            tableData: {
                type: Object,
                default: {}
            },
            bdata: {
                type: Object,
                default: {}
            },
        },
        data() {
            let typeText = this.$store.state.divData.type == 0 ? "单位" : "部门";
            var qksm = this.$store.state.divData.qksm;
            var arr = []
            var mcjsFourArr=[]
            for (let i in qksm) {
                let o = {};
                o[i] = qksm[i];
                arr.push(o)
            }
            for (var i = 0; i < arr.length; i++) {
                if (qksm['专业名词' + i] || qksm['专业名词解释' + i]) {
                    mcjsFourArr.push({ id: i, name: qksm['专业名词' + i], value: qksm['专业名词解释' + i] })
                }
            }
            return {
                loading: true,
                mcjs: [],
                qksm: qksm,
                tables: [],
                kemu: [],
                classType: ['一、收入类', '二、支出类', '三、支出科目类'],
                isPdf: Boolean,
                mcjsObject: [],
                name: 'mcjs',
                typeText: typeText,
                fixedItem: [
                    {
                        name: "收入类",
                        children:
                            [{
                                title: "财政拨款收入",
                                desc: "指本级财政当年拨付的资金，包括一般公共预算拨款收入和政府性基金预算拨款收入。其中：一般公共预算拨款收入包括财政部门经费拨款、专项收入、行政事业性收费收入、罚没收入、国有资源（资产）有偿使用收入和其他收入。",
                            }, {
                                title: "财政专户管理资金收入",
                                desc: "主要指事业单位的教育收费收入。",
                            }, {
                                title: "事业收入",
                                desc: "指事业单位开展专业业务活动及其辅助活动取得的收入。",
                            }, {
                                title: "上级补助收入",
                                desc: "指事业单位从主管部门和上级单位取得的非财政补助收入。",
                            }, {
                                title: "附属单位上缴收入",
                                desc: "指事业单位附属的独立核算单位按规定标准或比例缴纳的各项收入。",
                            }, {
                                title: "事业单位经营收入",
                                desc: "指事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动取得的收入。",
                            },
                            {
                                title: "其他收入",
                                desc: "指除上述“财政拨款收入”、“事业收入”、“经营收入”等以外的收入，如投资收益、利息收入等。",
                            }, {
                                title: "上年结转和结余",
                                desc: "指以前年度支出预算因客观条件变化未执行完毕、结转到本年度按有关规定继续使用的资金，既包括财政拨款结转和结余，也包括事业收入、经营收入、其他收入的结转和结余。",
                            }]
                    }, {
                        name: "支出类",
                        children: [{
                            title: "基本支出",
                            desc: "指为保障机构正常运转、完成日常工作任务而发生的人员支出和公用支出。",
                        }, {
                            title: "项目支出",
                            desc: "指在基本支出之外为完成特定行政任务和事业发展目标所发生的支出。",
                        },
                        {
                            title: "事业单位经营支出",
                            desc: "指事业单位在专业业务活动及其辅助活动之外开展非独立核算经营活动发生的支出。",
                        }, {
                            title: "上缴上级支出",
                            desc: "指附属单位上缴上级的支出。",
                        }, {
                            title: "对附属单位补助支出",
                            desc: "指预算单位对所属单位补助发生的支出。",
                        }, {
                            title: "一般公共预算“三公”经费支出",
                            desc: "指一般公共预算安排的因公出国（境）费、公务用车购置及运行费和公务接待费支出。其中，因公出国（境）费是指单位工作人员因公务出国（境）的往返机票费、住宿费、伙食费、培训费等支出；公务用车购置及运行费是指单位购置公务用车支出及公务用车使用过程中发生的租用费、燃料费、过路过桥费、保险费等支出；公务接待费支出是指单位按规定开支的各类公务接待（含外宾接待）支出。",
                        }, {
                            title: "机关运行经费",
                            desc: "为保障行政单位（含参照公务员法管理的事业单位）运行用于购买货物和服务的各项资金，包括办公及印刷费、邮电费、差旅费、会议费、福利费、日常维修费、专用材料及一般设备购置费、办公用房水电费、办公用房取暖费、办公用房物业管理费、公务用车运行维护费以及其他费用。",
                        }]
                    }],
                mcjsFour: mcjsFourArr,
                num3: false,
                num6: false,
            };
        },

        mounted() {
            let that = this
            this.fixedItem.forEach(function (chil, idx) {
                chil.children.forEach(function (item, index) {
                    item.desc = that.pickOneOf(that.qksm['mcjs_' + (idx + 1) + (index + 1)], item.desc)
                })
            })
            if (this.$parent.isPdf) {
                this.loading = false
                this.isPdf = true
                this.tables = this.tableData;
                this.mcjs = this.fixedItem;
                this.mcjsObject = this.preview(this.bdata.find(e => e.name == "mcjs").expr).result;
                this.T1 = this.preview(this.bdata.find(e => e.name == "T1").expr).result
                this.getTableData();
            } else {
                this.isPdf = false
                this.getDivData()
            }

        },
        methods: {
            appendRow() {
                this.mcjsFour.push({
                    id: this.mcjsFour.length>0 ? this.mcjsFour[this.mcjsFour.length-1].id+1 : this.mcjsFour.length,
                    name: '',
                    value: '',
                })
            },
            delect(id, index, num) {
                this.save("专业名词" + id, index, id,1)
                this.mcjsFour.splice(index, num)
            },
            async save(name,index,id,idx) {
                let form = {
                    id: this.$store.state.divid,
                    qk: name,
                    sm: ""
                }
                let res = await editQksm(form);
                if (res.status == 0 && idx==1) {
                    this.save("专业名词解释" + id, index)
                }
            },
            getDivData() {
                this.loading = true;
                getDivList({ id: this.$route.query.divid }).then((res) => {
                    this.tables = res.tables;
                    getBdata().then((res) => {
                        if (res.status == 0) {
                            this.mcjs = this.fixedItem
                            this.mcjsObject = this.preview(res.bdata.find(e => e.name == "mcjs").expr).result;
                            this.T1 = this.preview(res.bdata.find(e => e.name == "T1").expr).result
                            this.getTableData();
                        }
                        this.loading = false
                    })
                })

            },
            getTableData() {
                if (this.T1.收入.项目.filter(i => i.name.indexOf("事业收入") != -1).length > 0) {
                    this.num3 = true
                }
                if (this.T1.收入.项目.filter(i => i.name.indexOf("事业单位经营收入") != -1).length > 0) {
                    this.num6 = true
                }
                if (JSON.stringify(this.mcjsObject) == "[]" || this.mcjsObject.length == 0) {
                    return
                }
                let mcjsArr = []
                getKemuQuery({ codes: this.mcjsObject.map(e => { return e.code }).join(",") }).then((kemuRes) => {
                    try {
                        if (kemuRes.status == 0) {
                            for (let item of this.mcjsObject) {
                                let desc = this.qksm['mcjs_' + item.code]
                                if (desc == null || desc == undefined) {
                                    let code = item.code
                                    let thisKemu = kemuRes.list.find(e => e.code == code)
                                    if (thisKemu)
                                        desc = thisKemu.explain
                                    else {
                                        throw '找不到解释项：' + code
                                    }
                                }
                                mcjsArr.push({
                                    code: item.code,
                                    lei: item.lei,
                                    kuan: item.kuan,
                                    xiang: item.name,
                                    desc: desc
                                })
                            }
                            this.mcjs.push({ name: "支出科目类", children: mcjsArr })
                        }
                    }
                    catch (ex) {
                        this.addOrSet('mcjs', '名词解释存在数据错误，请检查。' + ex)
                    }
                })
                this.$nextTick(function () {
                    this.loading = false;
                });
            },
            preview(expr) {
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        result,
                    };
                } catch (ex) {
                    return {
                        ex,
                    };
                }
            },
        },
    }
</script>
<style scoped>
    .mcjs p b {
        font-family: SimHei !important;
    }

    .mcjs p {
        line-height: 2em;
        font-family: FangSong;
        font-size: 20px;
    }
</style>